import { Badge, Tooltip } from '@mui/material';

import { ThemaFromThemaRouter } from '../../../dtos';
import { theme } from '../../../theme/theme';
import { Tag } from '../Tag';
import { content } from './LeistungTag.content';

type LeistungTagProps = Readonly<{
  leistungtemplates: ThemaFromThemaRouter['leistungstemplates'];
}>;

export const LeistungTag = function ({ leistungtemplates }: LeistungTagProps) {
  const isEmpty = leistungtemplates.length === 0;

  if (isEmpty) {
    return (
      <Tooltip title={content.missingLeistungenTooltip} placement="bottom" arrow>
        <Badge
          badgeContent={content.emptyBadge}
          slotProps={{
            badge: {
              sx: {
                background: theme.palette.surface.disabledSolid,
                color: theme.palette.text.disabledSolid,
              },
            },
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <Tag style="disabled" size="default">
            {content.Lstg}
          </Tag>
        </Badge>
      </Tooltip>
    );
  }

  return (
    <Badge
      badgeContent={leistungtemplates.length}
      slotProps={{ badge: { sx: { background: theme.palette.surface.brandLight, color: theme.palette.text.brand } } }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <Tag style="brandLight" size="default">
        {content.Lstg}
      </Tag>
    </Badge>
  );
};
